module.exports = __webpack_public_path__ + "img/20211017_093012.9f5f6684.jpg";